import type { InvestorProfile } from "@ifgengineering/client-invest-sdk";
import type { AccreditationQuestionnaire } from "@components/onboarding/pages/Eligibility/types";
import type { AccreditationStage } from "./accreditationStage";
import type { CertificationSelection } from "./CertificationStep";

const DRAFT_KEY = "v2bAccreditationDraft";

/** The stages before anything is sent, which a refresh can land back on. */
export const DRAFT_STAGES: readonly AccreditationStage[] = [
  "certification",
  "questions",
  "declaration",
  "usDeclaration",
];

/** Answers only: a declaration is signed again after a refresh, never replayed. */
export interface AccreditationDraft {
  investorId: string;
  stage: AccreditationStage;
  selection: CertificationSelection | null;
  investorProfile?: InvestorProfile;
  accreditationAnswers: AccreditationQuestionnaire;
  investorProfileEligibilityReason: string;
}

export const saveAccreditationDraft = (draft: AccreditationDraft): void => {
  try {
    window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // Storage can be full or blocked; the flow still works without a draft.
  }
};

export const loadAccreditationDraft = (
  investorId: string | undefined
): AccreditationDraft | null => {
  if (!investorId) return null;
  try {
    const raw = window.sessionStorage.getItem(DRAFT_KEY);
    const draft = raw ? (JSON.parse(raw) as AccreditationDraft) : null;
    return draft?.investorId === investorId &&
      DRAFT_STAGES.includes(draft.stage)
      ? draft
      : null;
  } catch {
    return null;
  }
};

export const forgetAccreditationDraft = (): void => {
  try {
    window.sessionStorage.removeItem(DRAFT_KEY);
  } catch {
    // Nothing to clear when storage is unavailable.
  }
};
